// Extend the Window interface for AndroidBridge
import { isWebView } from '@src/helpers';

import { IWebViewEvent } from './types';

export function sendMessageToAndroid(message: IWebViewEvent) {
  if (!isWebView()) return;

  console.log('Mobile: Sending message to native:', JSON.stringify(message));
  const payload = JSON.stringify(message);

  // Android support
  if ((window as any).NativeBridge?.receiveFromJS) {
    console.log('Mobile: Using Android NativeBridge');
    (window as any).NativeBridge.receiveFromJS(payload);
  }
  // iOS WebKit support
  else if ((window as any).webkit?.messageHandlers?.nativeMessageHandler) {
    console.log('Mobile: Using iOS WebKit messageHandler');
    (window as any).webkit.messageHandlers.nativeMessageHandler.postMessage(message);
  } else {
    console.warn('Mobile: ❌ No native bridge available (neither iOS nor Android)');
  }
}
